import CeruleanReportEn from '../../../../assets/images/Campaign/Colour/Anna/cerulean-report-en.png';
import CeruleanReportTc from '../../../../assets/images/Campaign/Colour/Anna/cerulean-report-tc.png';
import CeruleanReportSc from '../../../../assets/images/Campaign/Colour/Anna/cerulean-report-sc.png';

import SkyblueReportEn from '../../../../assets/images/Campaign/Colour/Mack/skyblue-report-en.png';
import SkyblueReportTc from '../../../../assets/images/Campaign/Colour/Mack/skyblue-report-tc.png';
import SkyblueReportSc from '../../../../assets/images/Campaign/Colour/Mack/skyblue-report-sc.png';

import PomegranateReportEn from '../../../../assets/images/Campaign/Colour/Dina/pomegranate-report-en.png';
import PomegranateReportTc from '../../../../assets/images/Campaign/Colour/Dina/pomegranate-report-tc.png';
import PomegranateReportSc from '../../../../assets/images/Campaign/Colour/Dina/pomegranate-report-sc.png';

import OrchidpinkReportEn from '../../../../assets/images/Campaign/Colour/Payal/orchidpink-report-en.png';
import OrchidpinkReportTc from '../../../../assets/images/Campaign/Colour/Payal/orchidpink-report-tc.png';
import OrchidpinkReportSc from '../../../../assets/images/Campaign/Colour/Payal/orchidpink-report-sc.png';

import GreenseaReportEn from '../../../../assets/images/Campaign/Colour/Acton/greensea-report-en.png';
import GreenseaReportTc from '../../../../assets/images/Campaign/Colour/Acton/greensea-report-tc.png';
import GreenseaReportSc from '../../../../assets/images/Campaign/Colour/Acton/greensea-report-sc.png';

import JadeReportEn from '../../../../assets/images/Campaign/Colour/Aleksandra/jade-report-en.png';
import JadeReportTc from '../../../../assets/images/Campaign/Colour/Aleksandra/jade-report-tc.png';
import JadeReportSc from '../../../../assets/images/Campaign/Colour/Aleksandra/jade-report-sc.png';

import CarrotReportEn from '../../../../assets/images/Campaign/Colour/Ziggy/ziggy_report-en.png';
import CarrotReportTc from '../../../../assets/images/Campaign/Colour/Ziggy/ziggy_report-tc.png';
import CarrotReportSc from '../../../../assets/images/Campaign/Colour/Ziggy/ziggy_report-sc.png';

import CarrotReportHero from '../../../../assets/images/Campaign/Colour/Ziggy/ziggy_hero.png';

import SunflowerReportEn from '../../../../assets/images/Campaign/Colour/Sonia/sonia-report-en.png';
import SunflowerReportTc from '../../../../assets/images/Campaign/Colour/Sonia/sonia-report-tc.png';
import SunflowerReportSc from '../../../../assets/images/Campaign/Colour/Sonia/sonia-report-sc.png';

import { ColourTheme } from '../../../../types/ColourTheme';
import { SupportedLanguage } from '../../../../types/SupportedLanguage';

const personaToEnReport: Record<ColourTheme, string> = {
  [ColourTheme.cerulean]: CeruleanReportEn,
  [ColourTheme.skyblue]: SkyblueReportEn,
  [ColourTheme.pomegranate]: PomegranateReportEn,
  [ColourTheme.orchidpink]: OrchidpinkReportEn,
  [ColourTheme.greensea]: GreenseaReportEn,
  [ColourTheme.jade]: JadeReportEn,
  [ColourTheme.sunflower]: SunflowerReportEn,
  [ColourTheme.carrot]: CarrotReportEn,
  [ColourTheme.default]: CeruleanReportEn,
};

const personaToTcReport: Record<ColourTheme, string> = {
  [ColourTheme.cerulean]: CeruleanReportTc,
  [ColourTheme.skyblue]: SkyblueReportTc,
  [ColourTheme.pomegranate]: PomegranateReportTc,
  [ColourTheme.orchidpink]: OrchidpinkReportTc,
  [ColourTheme.greensea]: GreenseaReportTc,
  [ColourTheme.jade]: JadeReportTc,
  [ColourTheme.sunflower]: SunflowerReportTc,
  [ColourTheme.carrot]: CarrotReportTc,
  [ColourTheme.default]: CeruleanReportTc,
};

const personaToScReport: Record<ColourTheme, string> = {
  [ColourTheme.cerulean]: CeruleanReportSc,
  [ColourTheme.skyblue]: SkyblueReportSc,
  [ColourTheme.pomegranate]: PomegranateReportSc,
  [ColourTheme.orchidpink]: OrchidpinkReportSc,
  [ColourTheme.greensea]: GreenseaReportSc,
  [ColourTheme.jade]: JadeReportSc,
  [ColourTheme.sunflower]: SunflowerReportSc,
  [ColourTheme.carrot]: CarrotReportSc,
  [ColourTheme.default]: CeruleanReportSc,
};

export const personaToReportImg: Record<SupportedLanguage, Record<ColourTheme, string>> = {
  [SupportedLanguage.English]: personaToEnReport,
  [SupportedLanguage.Traditional_Chinese]: personaToTcReport,
  [SupportedLanguage.Simplified_Chinese]: personaToScReport,
};

export const carrotReportHero = CarrotReportHero;
